import React from 'react'
import { Link } from 'react-router-dom'

import { LinksWrap } from '../../../Quiz/components/Header/styled'

import { HeaderWrap, Button } from './styled'

import { InviteModal } from 'src/components/InviteModal/InviteModal'
import { QUIZZES_COMPLETED } from 'src/constants/routes'
import { InviteIcon, CloseIcon } from 'src/components/Icons'
import { breakpoints } from 'src/styles/media'
import { useMedia } from 'src/hooks/useMedia'
import { LogoLink } from 'src/components/LogoLink/LogoLink'

const Header: React.FC = () => {
  const [inviteModalOpen, setInviteModalOpen] = React.useState(false)

  const isDesktop = useMedia(breakpoints.desktop)

  return (
    <>
      <HeaderWrap>
        {isDesktop ? (
          <LogoLink />
        ) : (
          <Link to={QUIZZES_COMPLETED}>
            <CloseIcon />
          </Link>
        )}
        <LinksWrap>
          <Button onClick={() => setInviteModalOpen(true)}>
            <InviteIcon />
          </Button>
          {isDesktop && (
            <Link to={QUIZZES_COMPLETED}>
              <CloseIcon />
            </Link>
          )}
        </LinksWrap>
      </HeaderWrap>
      <InviteModal
        isOpen={inviteModalOpen}
        onClose={() => setInviteModalOpen(false)}
      />
    </>
  )
}

export default Header
